export const SETUP_WIZARD_SETTING_KEY = 'setup_wizard_completed'

export const SETUP_WIZARD_STEPS = [
  { id: 'identity', label: 'Identitate & Logo' },
  { id: 'company', label: 'Compania mea' },
  { id: 'shop', label: 'Tip magazin' },
  { id: 'woocommerce', label: 'Import WooCommerce' },
  { id: 'banner', label: 'Banner' },
  { id: 'integrations', label: 'Integrări' },
  { id: 'catalog', label: 'Primul produs' },
] as const

export type SetupWizardStepId = (typeof SETUP_WIZARD_STEPS)[number]['id']
